import { defineNuxtPlugin } from 'nuxt/app'
import { useRouterClient } from '~/composables/useRouterClient'

export default defineNuxtPlugin((nuxtApp) => {
  const routerClient = useRouterClient()
  nuxtApp.provide('routerClient', routerClient)
})
